/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachments200,
  GetApiV1PersonIdAttachments401,
  GetApiV1PersonIdAttachments404,
  GetApiV1PersonIdAttachments500,
  GetApiV1PersonIdAttachmentsPathParams,
  GetApiV1PersonIdAttachmentsQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachments.ts";
import { personAttachmentItemViewModelSchema } from "../personAttachmentItemViewModelSchema.ts";

export const getApiV1PersonIdAttachmentsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdAttachmentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachments200Schema = z.array(
  z.lazy(() => personAttachmentItemViewModelSchema),
) as unknown as ToZod<GetApiV1PersonIdAttachments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachments401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachments401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAttachments404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachments404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachments500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachments500>;

export const getApiV1PersonIdAttachmentsQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdAttachments200Schema,
) as unknown as ToZod<GetApiV1PersonIdAttachmentsQueryResponse>;
